export const InvestNow = ({ investClicked }) => {
  return (
    <div className="lil-justify-center xl:lil-hidden lg:lil-hidden">
      <div
        className="lil-bg-white lil-fixed lil-p-2 lil-w-full"
        style={{ bottom: 0 }}
      >
        <button
          className="lil-btn lil-btn-blue lil-w-full"
          onClick={() => investClicked(true)}
        >
          Invest Now
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/investNow.tsx